import React, { useEffect } from "react";
import { X } from "lucide-react"; // Import X icon from lucide-react

const Drawer = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      // Previne scroll da página atrás do drawer
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      // Restaura scroll normal
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
    }

    return () => {
      // Cleanup: sempre restaura o scroll ao desmontar
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        ></div>
      )}

      <div
        className={`fixed top-0 right-0 w-[70%] bg-white h-full shadow-lg transform transition-transform duration-300 ease-in-out z-50
          ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-gray-700">
              Gerenciar Colaboradores
            </h2>
            <button
              className="p-2 rounded-full hover:bg-gray-200 transition-colors"
              onClick={onClose}
            >
              <X size={20} className="text-gray-600" />
            </button>
          </div>

          {/* Conteúdo com scroll */}
          <div className="flex-1 overflow-y-auto p-4 min-h-0">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Drawer;
